// extracted by mini-css-extract-plugin
export default {"fullWidth":"En-z","image":"Fn-z","lazyLoadPicture":"Gn-z","lazyLoadSpinner":"Hn-z","lazyLoadSpin":"In-z","lazyLoadImage":"Jn-z","hasStyledAspectRatio":"Kn-z"};